export default "__VITE_ASSET__p5z2hWI1__"